import React from 'react'
import {Link as LinkScroll} from 'react-scroll'
import './Footer.css';

function Footer() {
  return (
    <div className="footer-container">
      <section className="social-media">
          <div className="social-media-wrap">
              <div className="footer-logo">
                <LinkScroll className='nezen-logo' activeClass="active" smooth spy to="home" offset={-100} >
                  <img src='/images/nezenHorizontalWhite.png' width="125px" height="auto"/> 
                </LinkScroll>
              </div>
              <small className="website-rights">NEZEN © 2026</small>
          </div>
      </section>
    </div>
  )
}

export default Footer
